

/* @flow */

import UnauthorizedError from 'shared/classes/UnauthorizedError';
import { loadingStart, loadingDone } from 'shared/actions/loading';

type Fetch = (url: string, options: ?any) => Promise<any>;

type Options = {
  baseUrl: string,
  cookie?: string,
  defaultAuth?: string,
};

const createFetch401Wrapper = fetchFunction => (url, options) => {
  if (
    typeof window === 'object' &&
    window.App &&
    window.App.dispatch &&
    typeof window.App.dispatch === 'function'
  ) {
    window.App.dispatch(loadingStart());
  }
  // console.time(url);
  return fetchFunction(url, options)
    .then(response => {
      if (response.status === 401) {
        throw new UnauthorizedError('UnauthorizedError');
      }

      return response;
    })
    .finally(() => {
      // console.timeEnd(url);
      if (
        typeof window === 'object' &&
        window.App &&
        window.App.dispatch &&
        typeof window.App.dispatch === 'function'
      ) {
        window.App.dispatch(loadingDone());
      }
    });
};

/**
 * Creates a wrapper function around the HTML5 Fetch API that provides
 * default arguments to fetch(...) and is intended to reduce the amount
 * of boilerplate code in the application.
 * https://developer.mozilla.org/docs/Web/API/Fetch_API/Using_Fetch
 */
function createFetch(fetch: Fetch, { baseUrl, defaultAuth }: Options) {
  // NOTE: Tweak the default options to suite your application needs
  const defaults = {
    mode: baseUrl ? 'cors' : 'same-origin',
    // credentials: baseUrl ? 'include' : 'same-origin',
    credentials: 'omit',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      cookie: null,
    },
    cache: 'no-store',
  };

  return createFetch401Wrapper((url: string, options: any) => {
    const isFormData = typeof window !== 'undefined' && options && options.body instanceof FormData;
    const { 'Content-Type': defaultContentType, ...defaultHeaders } = defaults.headers;
    const encodedURI = `${baseUrl}${encodeURI(decodeURIComponent(url))}`;

    return url.startsWith('/graphql') || url.startsWith('/api')
      ? fetch(encodedURI, {
          ...defaults,
          ...(url.startsWith('/graphql') ? { method: 'POST' } : {}),
          ...options,
          headers: {
            ...defaultHeaders,
            ...(isFormData ? {} : { 'Content-Type': defaultContentType }),
            ...(options && options.headers),
            // Provide default auth for desktop.s3.ua and mobile.s3.ua
            ...(defaultAuth || (options && options.headers && options.headers.Authorization)
              ? {
                  Authorization: [
                    options && options.headers && options.headers.Authorization,
                    defaultAuth,
                  ]
                    .filter(x => {
                      if (x === 'JWT ') {
                        return false;
                      }
                      if (!x) {
                        return false;
                      }
                      return true;
                    })
                    .join(', '),
                }
              : {}),
          },
        })
      : fetch(url, options);
  });
}

export default createFetch;



// WEBPACK FOOTER //
// ./src/createFetch.js